import jsLogic from 'json-logic-js'
import { enhanceJSLogic } from './utils/utils'

// TODO place ad banner rules here

const validate = (eventData: unknown, rules: jsLogic.RulesLogic<jsLogic.AdditionalOperation>) =>
  jsLogic.apply(rules, eventData)

export const initJsLogic = () => {
  enhanceJSLogic()
  return validate
}
